import React                    from 'react';
import { connect }              from 'react-redux';
import { reducerType }          from 'reducer';
import { componentsStateType }  from 'reducer/types';
import Tens                     from 'components/Tens';
import box_0                    from 'images/box_0.png';
import box_1                    from 'images/box_1.png';
import box_2                    from 'images/box_2.png';
import box_3                    from 'images/box_3.png';
import box_4                    from 'images/box_4.png';
import box_5                    from 'images/box_5.png';
import box_6                    from 'images/box_6.png';
import box_7                    from 'images/box_7.png';
import box_8                    from 'images/box_8.png';
import box_9                    from 'images/box_9.png';
import box_10                   from 'images/box_10.png';
import sizes                    from 'utils/sizes';
import { makeStyles/* , theme */ }           from "makeStyles";
import { objType } from 'types';
import { getPage } from '../pages';

const arr = [box_0, box_1, box_2, box_3, box_4, box_5, box_6, box_7, box_8, box_9, box_10];


const useStyles = makeStyles()(
  (theme) => ({
  root: {
     display:        'flex',
     alignItems:     'center',
     justifyContent: 'center',
  },
  image: {
    backgroundPosition: 'center',
    backgroundSize:     'contain',
    backgroundRepeat:   'no-repeat',
    display:            'flex',
    alignItems:         'center',
    flexFlow:           'column',
    touchAction:        'manipulation',
    zIndex:              2
  },
  text: {
    position:        'absolute', 
    display:         'flex',
    alignItems:      'center',
    justifyContent:  'center',
    color:           theme.blue,
    fontSize:        23,
  }
})
);

type DroppableProps = {
  variant:           string;
  wideScreen:        boolean;
  correctVal:        number;
  pageNum:           number;
  value:             number;
  finalPositions:    boolean[];
  componentsState:   componentsStateType;
  droppablePos0:     objType;
  droppablePos1:     objType;
  setDroppablePos0:  (val: objType) => void;
  setDroppablePos1:  (val: objType) => void;
  setFinalPositions: (val: boolean[]) => void;
}

const Droppable: React.FC<DroppableProps> = ({ 
  variant,
  wideScreen,
  correctVal,
  pageNum,
  value,
  finalPositions,
  componentsState,
  droppablePos0,
  setDroppablePos0,
  droppablePos1,
  setDroppablePos1,
  setFinalPositions,
}) => {

  const { classes } = useStyles();


  const unitRef = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {

    if (unitRef && unitRef.current) {

       const { x, y } = unitRef.current.getBoundingClientRect();

       if (variant === 'tens' && !finalPositions[0]) {
 
           setDroppablePos0(
             { 
               x: x.toFixed(1),
               y: y.toFixed(1),
             }
           )
 
           setFinalPositions([true, finalPositions[1]])
 
       }

       if (variant === 'units' && !finalPositions[1]) {
         
        setDroppablePos1(
          { 
            x: x.toFixed(1),
            y: y.toFixed(1)
          }
        )

        setFinalPositions([finalPositions[0], true])

    }
 
    }
       
   },[unitRef,variant,finalPositions, setFinalPositions, setDroppablePos0, setDroppablePos1])


  const [rootStyle, imageStyle] = React.useMemo(() => {

    const { bigBoxWidth, bigBoxHeight, smallBoxHeight } = sizes;

    const width          = wideScreen ? bigBoxWidth : '19vw';
    const showCorrectVal = value === -1 && componentsState.failurCount > 2;
    const image          = !!variant && variant === 'tens' && value > 1 ? 'none' : showCorrectVal ? `url(${ arr[correctVal] })` : `url(${ arr[value] })`;


    return[
      {
         height:       '100%',
         width:        width,
         paddingLeft:  10,
         paddingRight: 10,
         borderRadius: '0.5em',
      },
      {
        backgroundImage: image,
        width:           width,
        height:          wideScreen ? bigBoxHeight : smallBoxHeight,
        opacity:         showCorrectVal ? 0.5 : 1
      }
    ]
  },[value, wideScreen, correctVal, componentsState, variant]);



  
  return (
    <div 
      className = { classes.root }
      ref       = { unitRef } 
      style     = { rootStyle }
    >
      {
        pageNum <= getPage('dragTen1') &&
        <div className = { classes.text }>
          { variant === 'tens' ? 'עשרות' : 'יחידות' }
        </div>
      }
      <div 
        className = { classes.image }
        style     = { imageStyle }
      >
        {
          !!variant && variant === 'tens' && value > 1 &&
            <Tens
              value      = { value } 
              wideScreen = { wideScreen }
              position   = { 'undefined' }
            />
        }
        </div>
    </div>
  );
}


const mapStateToProps = (reducer: reducerType) => {
  return {
    componentsState: reducer.components
  }
};

/* 
const mapDispatchToProps = (dispatch: Dispatch<ActionTypes>) => ({
  setComponentsState: (payload: objType) => dispatch(SET_COMPONENTS_STATE(payload)),
});
 */
export default connect(mapStateToProps)(Droppable);


